import React, { Component } from 'react';
import './Gallery.css';
import GalleryImages from './gallery-images/GalleryImages';
import {
  convertObjectToArray,
  hideComponent } from '../../redux/helpers';
import ScrollArrow from '../scroll-arrow/ScrollArrow';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayTopArrow: false,
      displayBottomArrow: false,
      hideComponent: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
  }

  /* componentDidUpdate(nextProps) {
    if (nextProps.images.length !== this.props.images.length) {
      this.toggleArrow();
    }
  } */

  toggleArrow = () => {
    const target = document.querySelector('.GalleryWrapper');
    if (target) {
      const targetOffsetHeight = target.clientHeight;
      const targetScrollHeight = target.scrollHeight;

      if (targetScrollHeight === targetOffsetHeight) {
        this.toggleBottomArrow(false);
      }

      if (targetScrollHeight > targetOffsetHeight) {
        this.toggleBottomArrow(true);
      }
    }
  }

  toggleTopArrow = (visible) => {
    this.setState({
      displayTopArrow: visible,
    });
  }

  toggleBottomArrow = (visible) => {
    this.setState({
      displayBottomArrow: visible,
    });
  }

  displayArrow = (direction, target, state) => (
    state ?
      <ScrollArrow
        direction={direction}
        classes="ScrollLeft galleryScroll"
        target={target}
        vertical={false}
      />
      :
      ''
  )

  renderGalleryImages = () => {
    const imagesArray = convertObjectToArray(this.props.images);
    const {
      hideComponent,
      displayTopArrow,
      displayBottomArrow,
    } = this.state;

    if (hideComponent) {
      return false;
    }

    return (
      <div className="Gallery" data-html2canvas-ignore>
        {this.displayArrow('left', '.GalleryWrapper', displayTopArrow)}
        <GalleryImages
          toggleTopArrow={this.toggleTopArrow.bind(this)}
          toggleBottomArrow={this.toggleBottomArrow.bind(this)}
          images={imagesArray}
          imageslength={imagesArray.length}
        />
        {this.displayArrow('right', '.GalleryWrapper', displayBottomArrow)}
      </div>
    );
  }

  render() {
    return (
      this.renderGalleryImages()
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.jsx